import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function SlashForwardIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M6 14L10 2"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default SlashForwardIcon;
